import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useLocation } from 'react-router-dom';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import cls from 'classname';
import { Divider, Spin } from 'antd';
import openNotification from '../../Components/Notification';
import Modal from '../../Components/Modal';
import Icon from '../../Icon';
import Creators from './reducer';
import ButtonComponent from '../../Components/Button';
import './styles.less';

const WarningBanner = ({ text }) => {

  const theme = useSelector(state => state?.nav?.theme);

  return (
    <p className={'shopify-connect-new-result-info-data-warning'}>
      {
        theme === 'light' ?
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path fillRule="evenodd"
                  clipRule="evenodd"
                  d="M9.63618 3.25763C10.7021 1.46491 13.2977 1.4649 14.3636 3.25763L21.8476 15.8443C22.9376 17.6774 21.6165 19.9998 19.4839 19.9998L4.51593 19.9998C2.38326 19.9998 1.06225 17.6774 2.15221 15.8443L9.63618 3.25763ZM12 7.99976C12.4142 7.99976 12.75 8.33554 12.75 8.74976V12.7498C12.75 13.164 12.4142 13.4998 12 13.4998C11.5858 13.4998 11.25 13.164 11.25 12.7498V8.74976C11.25 8.33554 11.5858 7.99976 12 7.99976ZM13 15.4998C13 16.052 12.5523 16.4998 12 16.4998C11.4477 16.4998 11 16.052 11 15.4998C11 14.9475 11.4477 14.4998 12 14.4998C12.5523 14.4998 13 14.9475 13 15.4998Z"
                  fill="#F6B60E"
            />
          </svg>
          :
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M9.63618 3.25763C10.7021 1.46491 13.2977 1.4649 14.3636 3.25763L21.8476 15.8443C22.9376 17.6774 21.6165 19.9998 19.4839 19.9998L4.51593 19.9998C2.38326 19.9998 1.06225 17.6774 2.15221 15.8443L9.63618 3.25763ZM12 7.99976C12.4142 7.99976 12.75 8.33554 12.75 8.74976V12.7498C12.75 13.164 12.4142 13.4998 12 13.4998C11.5858 13.4998 11.25 13.164 11.25 12.7498V8.74976C11.25 8.33554 11.5858 7.99976 12 7.99976ZM13 15.4998C13 16.052 12.5523 16.4998 12 16.4998C11.4477 16.4998 11 16.052 11 15.4998C11 14.9475 11.4477 14.4998 12 14.4998C12.5523 14.4998 13 14.9475 13 15.4998Z"
                  fill="#F6B60E" />
          </svg>
      }
      <span>
        {
          text
        }
      </span>
    </p>
  );
};

const nichesIcons = (theme) => (
  {
    0: (
      <svg xmlns="http://www.w3.org/2000/svg"
           width="20"
           height="20"
           viewBox="0 0 20 20"
           fill="none"
      >
        <path stroke={theme === 'light' ? '#A1AAC8' : 'rgba(255, 255, 255, .26'}
              d="M8.12496 7.70817C8.12496 7.01781 8.6846 6.45817 9.37496 6.45817H10.3822C11.2066 6.45817 11.875 7.1265 11.875 7.95093C11.875 8.45004 11.6255 8.91613 11.2102 9.19299L10.7421 9.50506C10.2785 9.81417 9.99996 10.3346 9.99996 10.8918V11.0415M9.99996 13.3332V13.3248M17.7083 9.99984C17.7083 14.257 14.2572 17.7082 9.99996 17.7082C5.74276 17.7082 2.29163 14.257 2.29163 9.99984C2.29163 5.74264 5.74276 2.2915 9.99996 2.2915C14.2572 2.2915 17.7083 5.74264 17.7083 9.99984ZM10.2083 13.3332C10.2083 13.4482 10.115 13.5415 9.99996 13.5415C9.8849 13.5415 9.79163 13.4482 9.79163 13.3332C9.79163 13.2181 9.8849 13.1248 9.99996 13.1248C10.115 13.1248 10.2083 13.2181 10.2083 13.3332Z"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
        />
      </svg>
    ),
    1: (
      <svg xmlns="http://www.w3.org/2000/svg"
           width="20"
           height="20"
           viewBox="0 0 20 20"
           fill="none"
      >
        <path stroke={theme === 'light' ? '#A1AAC8' : 'rgba(255, 255, 255, .26'}
              d="M12.5 6.66667C12.5 8.04738 11.3807 9.16667 10 9.16667C8.61929 9.16667 7.5 8.04738 7.5 6.66667M3.86343 4.69084L3.23212 15.1075C3.17404 16.0659 3.93561 16.875 4.89573 16.875H15.1043C16.0644 16.875 16.826 16.0659 16.7679 15.1075L16.1366 4.69084C16.0833 3.81114 15.3543 3.125 14.473 3.125H5.52705C4.64573 3.125 3.91675 3.81114 3.86343 4.69084Z"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
        />
      </svg>
    ),
    2: (
      <svg xmlns="http://www.w3.org/2000/svg"
           width="20"
           height="20"
           viewBox="0 0 20 20"
           fill="none"
      >
        <path stroke={theme === 'light' ? '#A1AAC8' : 'rgba(255, 255, 255, .26'}
              d="M14.375 15.2083H16.25M3.12504 13.9583V4.79167C3.12504 3.87119 3.87123 3.125 4.79171 3.125H15.2084C16.1288 3.125 16.875 3.87119 16.875 4.79167V7.29167M3.12504 13.9583H1.45837V15.2083C1.45837 16.1288 2.20457 16.875 3.12504 16.875H11.875M3.12504 13.9583H11.875M16.875 7.29167H13.5417C12.6212 7.29167 11.875 8.03786 11.875 8.95833V16.0417C11.875 16.9621 12.6212 17.7083 13.5417 17.7083H16.875C17.7955 17.7083 18.5417 16.9621 18.5417 16.0417V8.95833C18.5417 8.03786 17.7955 7.29167 16.875 7.29167Z"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
        />
      </svg>
    ),
    3: (
      <svg xmlns="http://www.w3.org/2000/svg"
           width="20"
           height="20"
           viewBox="0 0 20 20"
           fill="none"
      >
        <path stroke={theme === 'light' ? '#A1AAC8' : 'rgba(255, 255, 255, .26'}
              d="M16.0417 6.20043L10.7762 2.43077C10.497 2.23086 10.3573 2.13091 10.205 2.09225C10.0705 2.05812 9.92957 2.05812 9.79505 2.09225C9.64272 2.13091 9.5031 2.23086 9.22388 2.43077L3.95835 6.20044M16.0417 6.20043L17.9167 7.54277M16.0417 6.20043V14.2084C16.0417 15.1419 16.0417 15.6086 15.86 15.9651C15.7002 16.2787 15.4453 16.5337 15.1317 16.6935C14.7751 16.8751 14.3084 16.8751 13.375 16.8751H6.62502C5.6916 16.8751 5.22489 16.8751 4.86837 16.6935C4.55476 16.5337 4.2998 16.2787 4.14001 15.9651C3.95835 15.6086 3.95835 15.1419 3.95835 14.2084V6.20044M3.95835 6.20044L2.08337 7.54277"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
        />
      </svg>
    ),
    4: (
      <svg xmlns="http://www.w3.org/2000/svg"
           width="20"
           height="20"
           viewBox="0 0 20 20"
           fill="none"
      >
        <path
          d="M10.4171 8.54997L10.2475 9.28054C10.4344 9.32394 10.6309 9.29404 10.7964 9.19697L10.4171 8.54997ZM12.4722 7.69585L12.6663 8.42029L12.4722 7.69585ZM6.76811 7.70267L6.93775 6.97211C6.69193 6.91503 6.43388 6.9854 6.25107 7.15938C6.06826 7.33336 5.9852 7.58761 6.03005 7.83595L6.76811 7.70267ZM7.52294 11.8826L8.23242 12.1258C8.2739 12.0048 8.28374 11.8752 8.26101 11.7493L7.52294 11.8826ZM7.41518 14.3763L6.69073 14.5705L7.41518 14.3763ZM14.6791 7.408L14.6741 8.15798C14.8711 8.1593 15.0607 8.08308 15.2019 7.94578L14.6791 7.408ZM8.70528 17.3965C9.04257 17.6369 9.51091 17.5584 9.75134 17.2211C9.99178 16.8838 9.91326 16.4155 9.57597 16.1751L8.70528 17.3965ZM10.7964 9.19697C11.3553 8.86933 11.9834 8.60327 12.6663 8.42029L12.2781 6.9714C11.4665 7.18886 10.7136 7.50673 10.0378 7.90297L10.7964 9.19697ZM6.59847 8.43323L10.2475 9.28054L10.5867 7.81941L6.93775 6.97211L6.59847 8.43323ZM8.26101 11.7493L7.50617 7.56939L6.03005 7.83595L6.78488 12.0159L8.26101 11.7493ZM8.13962 14.1822C7.95943 13.5097 7.99791 12.8099 8.23242 12.1258L6.81347 11.6394C6.49159 12.5784 6.42624 13.5833 6.69073 14.5705L8.13962 14.1822ZM16.3522 4.73566L14.1564 6.87022L15.2019 7.94578L17.3978 5.81122L16.3522 4.73566ZM12.6663 8.42029C13.3492 8.2373 14.0263 8.15364 14.6741 8.15798L14.6842 6.65802C13.9007 6.65277 13.0897 6.75393 12.2781 6.9714L12.6663 8.42029ZM9.57597 16.1751C8.85455 15.6608 8.35343 14.9802 8.13962 14.1822L6.69073 14.5705C7.00572 15.746 7.73699 16.7063 8.70528 17.3965L9.57597 16.1751ZM5.125 3.875H14.875V2.375H5.125V3.875ZM16.125 5.125V14.875H17.625V5.125H16.125ZM14.875 16.125H5.125V17.625H14.875V16.125ZM3.875 14.875V5.125H2.375V14.875H3.875ZM5.125 16.125C4.43464 16.125 3.875 15.5654 3.875 14.875H2.375C2.375 16.3938 3.60622 17.625 5.125 17.625V16.125ZM16.125 14.875C16.125 15.5654 15.5654 16.125 14.875 16.125V17.625C16.3938 17.625 17.625 16.3938 17.625 14.875H16.125ZM14.875 3.875C15.5654 3.875 16.125 4.43464 16.125 5.125H17.625C17.625 3.60622 16.3938 2.375 14.875 2.375V3.875ZM5.125 2.375C3.60622 2.375 2.375 3.60622 2.375 5.125H3.875C3.875 4.43464 4.43464 3.875 5.125 3.875V2.375Z"
          fill={theme === 'light' ? '#A1AAC8' : 'rgba(255, 255, 255, .26'} />
        <path
          d="M11.6581 12.0749C11.8109 12.6451 11.5495 13.2105 11.0743 13.3379C10.5992 13.4652 10.0901 13.1061 9.9373 12.5359C9.78451 11.9657 10.0459 11.4003 10.521 11.2729C10.9962 11.1456 11.5053 11.5046 11.6581 12.0749Z"
          fill={theme === 'light' ? '#A1AAC8' : 'rgba(255, 255, 255, .26'} />
        <path
          d="M16.82 10.6916C16.9728 11.2618 16.7115 11.8273 16.2363 11.9546C15.7611 12.0819 15.252 11.7229 15.0993 11.1527C14.9465 10.5825 15.2078 10.017 15.683 9.88967C16.1582 9.76234 16.6672 10.1214 16.82 10.6916Z"
          fill={theme === 'light' ? '#A1AAC8' : 'rgba(255, 255, 255, .26'} />
        <path
          d="M15.057 13.7461C15.1589 14.1263 14.7792 14.5583 14.209 14.7111C13.6387 14.8639 13.0939 14.6796 12.9921 14.2994C12.8902 13.9193 13.2699 13.4873 13.8401 13.3345C14.4103 13.1817 14.9551 13.366 15.057 13.7461Z"
          fill={theme === 'light' ? '#A1AAC8' : 'rgba(255, 255, 255, .26'}
        />
      </svg>
    ),
    5: (
      <svg xmlns="http://www.w3.org/2000/svg"
           width="20"
           height="20"
           viewBox="0 0 20 20"
           fill="none"
      >
        <path stroke={theme === 'light' ? '#A1AAC8' : 'rgba(255, 255, 255, .26'}
              d="M7.14925 2.83579L9.02032 4.19521C9.60446 4.61961 10.3955 4.61961 10.9796 4.19521L12.8507 2.83579M7.14925 2.83579C8.03105 2.4846 8.99295 2.2915 9.99996 2.2915C11.007 2.2915 11.9689 2.4846 12.8507 2.83579M7.14925 2.83579C5.94217 3.31653 4.8852 4.09351 4.06815 5.07692M4.06815 5.07692C2.95873 6.41222 2.29163 8.12812 2.29163 9.99984C2.29163 10.1665 2.29692 10.3319 2.30734 10.496M4.06815 5.07692L4.78215 7.27441C5.00528 7.96112 4.76085 8.7134 4.1767 9.1378L2.30734 10.496M2.30734 10.496C2.39165 11.8233 2.81191 13.0594 3.48402 14.1201M3.48402 14.1201H5.79554C6.51758 14.1201 7.15751 14.585 7.38063 15.2717L8.09524 17.471M3.48402 14.1201C4.5229 15.7595 6.16348 16.9801 8.09524 17.471M8.09524 17.471C8.70443 17.6259 9.34259 17.7082 9.99996 17.7082C10.6573 17.7082 11.2955 17.6259 11.9047 17.471M11.9047 17.471L12.6193 15.2717C12.8424 14.585 13.4823 14.1201 14.2044 14.1201H16.5159M11.9047 17.471C13.8364 16.9801 15.477 15.7595 16.5159 14.1201M16.5159 14.1201C17.188 13.0594 17.6083 11.8233 17.6926 10.496M17.6926 10.496C17.703 10.3319 17.7083 10.1665 17.7083 9.99984C17.7083 8.12812 17.0412 6.41222 15.9318 5.07692M17.6926 10.496L15.8232 9.1378C15.2391 8.7134 14.9946 7.96112 15.2178 7.27441L15.9318 5.07692M15.9318 5.07692C15.1147 4.09351 14.0577 3.31653 12.8507 2.83579M7.79837 10.3146L8.03385 11.0393C8.25697 11.726 8.8969 12.1909 9.61895 12.1909H10.381C11.103 12.1909 11.7429 11.726 11.9661 11.0393L12.2015 10.3146C12.4247 9.62785 12.1802 8.87557 11.5961 8.45116L10.9796 8.00326C10.3955 7.57885 9.60446 7.57885 9.02032 8.00326L8.40382 8.45117C7.81968 8.87557 7.57525 9.62785 7.79837 10.3146Z"
              strokeWidth="1.5"
              strokeLinejoin="round"
        />
      </svg>
    ),
  }
)

const options = [
  {
    title: 'I have a Shopify Store',
    text: 'If you have a Shopify store - select this option.',
    icon: 'have',
    iconBg: 'rgba(149, 191, 71, 0.15)',
  },
  {
    title: 'Use AI to generate store',
    text: 'Artificial Intelligence will help you to generate a prebuilt store',
    icon: 'ai',
    iconBg: '#F2F6FF',
  },
  {
    title: 'I don’t have a Shopify Store',
    text: 'Select this option if you want to generate a store by yourself',
    icon: 'dont',
    iconBg: '#F2F6FF',
  },
];

const ModalShopifyConnect = (
  {
    isMobile,
    theme,
    userInfo,
    shopifyStore,
    ...props
  }) => {

  const {
    nichesStep,
    preBuiltStores,
    nicheCreated,
    nichesLoading,
    niches,
    isVisibleModal,
    verifyErrors,
    verifyResult,
    initialUrl,
  } = shopifyStore;
  const { t } = useTranslation();
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedNiche, setSelectedNiche] = useState(null);

  const checkOauth = shopifyStore?.checkOauth;

  useEffect(() => {
    if (location?.search && location?.search.includes('.myshopify.com') && !location?.pathname.includes('shopify/app')) {
      props.verifyShopifyStore(location?.search);
    }
    dispatch(Creators.resetOauth());
    /*eslint-disable-next-line react-hooks/exhaustive-deps*/
  }, []);

  useEffect(() => {
    if (!checkOauth && typeof checkOauth !== 'object' && isVisibleModal === 'connect') openNotification({
      type: 'warning',
      message: t('This store is already connected.'),
      style: { minWidth: '716px' },
    });
    /*eslint-disable-next-line react-hooks/exhaustive-deps*/
  }, [checkOauth, isVisibleModal]);

  useEffect(() => {
    if (verifyResult || verifyErrors) {
      navigate(initialUrl || '/setting/account', { replace: true });
      if (verifyResult) {
        openNotification({
          message: t('Your Shopify store has been successfully connected'),
          style: { minWidth: '716px' },
        });
        handleClose();
      }
      if (verifyErrors) {
        openNotification({
          message: t('Something went wrong, kindly try again'),
          style: { minWidth: '716px' },
          type: 'error',
        });
      }
      props.verifyShopifyStoreReset();
    }
    /*eslint-disable-next-line react-hooks/exhaustive-deps*/
  }, [verifyResult, verifyErrors]);

  const handleClose = () => {
    props.closeModalConnect();
    props.resetNiches();
    setTimeout(() => {
      setSelectedOption(null);
      setSelectedNiche(null);
      props.setNichesStep(1);
    }, 500);
  };

  const handleOk = () => {
    if (nichesStep === 1) {
      if (selectedOption === 'ai') {
        props.setNichesStep(2);
      } else {
        handleClose();
        window.open(selectedOption === 'have' ?
            'https://apps.shopify.com/dropship-10?show_store_picker=1'
            :
            'https://shopify.pxf.io/dropship.io'
          , '_self');
      }
    } else {
      props.setNichesStep(nichesStep === 0 ? nichesStep + 4 : nichesStep + 1);
    }
  };

  const handleCopy = (value, name) => {
    navigator.clipboard.writeText(value);
    openNotification({
      message: `${name} was copied!`,
      style: { minWidth: '716px' },
    });
  };

  const modalTitle = {
    0: (
      <div style={{
        display: 'flex',
        alignItems: 'center',
      }}
           className={'custom-modal-title'}
      >
        {
          t('My Ai Stores')
        }
        <span className={'badge'}>
            {
              props.dashboardInfo?.ai_stores_count
            }
          </span>
      </div>
    ),
    1: <div className={'custom-modal-title'}>{t('Connect your Shopify store to Dropship.')}</div>,
    2: <div className={'custom-modal-title'}>{t('Select your niche')}</div>,
    3: <div className={'custom-modal-title'}>{t('Your Custom AI Shopify Store is Underway!')}</div>,
    4: <div className={'custom-modal-title'}>{t('Congratulations!')}</div>,
  };


  const modalContent = {
    0: (
      <Spin spinning={false}>
        <p className={'custom-modal-text'}>
          {t('Here are Shopify stores you’ve previously created.')}
        </p>
        {
          nichesLoading ?
            <div className="shopify-connect-new-created-stores-wrapper">
              {
                [1, 2, 3, 4].map(el => (
                  <div className={'shopify-connect-new-created-store'}
                       key={el}
                  >
                    <div className={'shopify-connect-new-created-store-icon'}>
                      <span className={'link skeleton'} style={{ width: '100%', height: '100%', borderRadius: 12 }} />
                    </div>
                    <div className={'shopify-connect-new-created-store-title-wrapper'}>
                      <h5 className="shopify-connect-new-created-store-title">
                        <span className={'link skeleton'} style={{ width: 70, height: 20, display: 'block' }} />
                      </h5>
                      <p className="shopify-connect-new-created-store-domain">
                        <span className={'link skeleton'} style={{ width: 92, height: 20, display: 'block' }} />
                      </p>
                    </div>
                    <div className="shopify-connect-new-created-store-btn">
                      <span className={'link skeleton'} style={{ width: isMobile ? 24 : 120, height: 20 }} />
                    </div>
                  </div>
                ))
              }
            </div>
            :
            <div className="shopify-connect-new-created-stores-wrapper">
              {
                preBuiltStores.map(el => (
                  <div className={cls('shopify-connect-new-created-store')}
                       key={el?.id}
                       onClick={() => {
                         props.getPreBuiltStoreById(el?.id);
                         handleOk();
                       }}
                  >
                    <div className={'shopify-connect-new-created-store-icon'}>
                      {
                        nichesIcons(theme)?.[el?.niche_id] || <Icon type={`shopify_connect_new_have`} role={'icon'} />
                      }
                    </div>
                    <div className={'shopify-connect-new-created-store-title-wrapper'}>
                      <h5 className="shopify-connect-new-created-store-title">
                        {
                          el?.name.replaceAll(' ', '-')
                        }
                      </h5>
                      <p className="shopify-connect-new-created-store-domain">
                        {
                          el?.store_url
                        }
                      </p>
                    </div>
                    <div className="shopify-connect-new-created-store-btn">
                      {
                        isMobile ?
                          null
                          :
                          t('View Details')
                      }
                      <Icon role="icon"
                            type="arrow_breadcrumb"
                            width={24}
                            height={24}
                      />
                    </div>
                  </div>
                ))
              }
            </div>
        }
      </Spin>
    ),
    1: (
      <Spin spinning={false}>
        <p className={'custom-modal-text'}>
          {t('It takes just 1 minute to set up.')}
        </p>
        <div className={'shopify-connect-new-options-wrapper'}>
          {
            options.map(el => (
              <div className={cls('shopify-connect-new-option', {
                'shopify-connect-new-option--selected': selectedOption === el?.icon,
              })}
                   key={el?.icon}
                   onClick={() => setSelectedOption(el?.icon)}
              >
                <Icon type={`shopify_connect_new_${el?.icon}`}
                      role={'icon'}
                />
                <div className={'shopify-connect-new-option-text'}>
                  <h4>
                    {t(el?.title)}
                  </h4>
                  <span>
                    {t(el?.text)}
                  </span>
                </div>
                <div className="shopify-connect-new-option-check" />
              </div>
            ))
          }
        </div>
        {
          isMobile ?
            null
            :
            <Divider type={'horizontal'}
                     style={{ margin: '0 auto 16px' }}
            />
        }
        <div className={'custom-modal-btn-wrapper'}>
          <ButtonComponent className={cls('custom-modal-button cancel')}
                           onClick={() => handleClose()}
          >
            {t('Cancel')}
          </ButtonComponent>
          <ButtonComponent className={cls('custom-modal-button apply blue')}
                           onClick={() => handleOk()}
                           disabled={!Boolean(selectedOption)}
          >
            {t('Continue')}
          </ButtonComponent>
        </div>
      </Spin>
    ),
    2: (
      <Spin spinning={false}>
        <p className={'custom-modal-text'}>
          {t('Select niche which aligns with your interests and target audience.')}
        </p>
        {
          nichesLoading ?
            <div className="shopify-connect-new-options-wrapper shopify-connect-niches-wrapper">
              {
                [1, 2, 3, 4, 5].map(el => (
                  <div className={'shopify-connect-new-option'}
                       key={el}
                       style={{ padding: 0 }}
                  >
                    <span className={'link skeleton'} style={{ width: '100%', height: 52, borderRadius: 12 }} />
                  </div>
                ))
              }
            </div>
            :
            <div className="shopify-connect-new-options-wrapper shopify-connect-niches-wrapper">
              {
                niches.map(el => (
                  <div className={cls('shopify-connect-new-option', {
                    'shopify-connect-new-option--selected': selectedNiche === el?.id,
                  })}
                       style={{
                         alignItems: 'center',
                       }}
                       key={el?.name}
                       onClick={() => setSelectedNiche(el?.id)}
                  >
                    {
                      nichesIcons(theme)?.[el?.id] ?
                        nichesIcons(theme)?.[el?.id]
                        :
                        nichesIcons(theme)?.[0]
                    }
                    <div className="shopify-connect-new-option-text">
                      <h4 className={'shopify-connect-new-option-title'}>
                        {el?.name}
                      </h4>
                    </div>
                    <div className="shopify-connect-new-option-check" />
                  </div>
                ))
              }
            </div>
        }
        {
          isMobile ?
            null
            :
            <Divider type={'horizontal'}
                     style={{ margin: '0 auto 16px' }}
            />
        }
        <div className={'custom-modal-btn-wrapper'}>
          <ButtonComponent className={cls('custom-modal-button no-border')}
                           onClick={() => props.setNichesStep(1)}
          >
            {
              isMobile ?
                <svg xmlns="http://www.w3.org/2000/svg"
                     width="20"
                     height="20"
                     viewBox="0 0 20 20"
                     fill="none"
                >
                  <path d="M11.3221 13.3334L8.57806 10.5893C8.25262 10.2639 8.25263 9.73626 8.57806 9.41083L11.3221 6.66675"
                        stroke="#707BA0"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                  />
                </svg>
                :
                t('Go Back')
            }
          </ButtonComponent>
          <ButtonComponent className={cls('custom-modal-button cancel')}
                           onClick={() => handleClose()}
          >
            {t('Cancel')}
          </ButtonComponent>
          <ButtonComponent className={cls('custom-modal-button apply blue')}
                           onClick={() => {
                             props.createPreBuiltStore(selectedNiche);
                             handleOk();
                           }}
                           disabled={!Boolean(selectedNiche)}
          >
            {t('Continue')}
          </ButtonComponent>
        </div>
      </Spin>
    ),
    3: (
      <Spin spinning={false}>
        <p className={'custom-modal-text'}>
          {t('We\'ll have it ready shortly. Thank you for your patience.')}
        </p>
        <Spin spinning={true}>
          <div className="shopify-connect-new-spinner-wrapper" />
        </Spin>
      </Spin>
    ),
    4: (
      <Spin spinning={false}>
        <p className={'custom-modal-text'}>
          {t('Your store has been successfully created')}
        </p>
        <div className="shopify-connect-new-result-wrapper">
          <div className="shopify-connect-new-result-info">
            <div className="shopify-connect-new-result-info-title">
              <div className="shopify-connect-new-result-info-title-number">
                01
              </div>
              <span>
                {t('Navigate to your Shopify account to update your login information')}
              </span>
            </div>
            <div className="shopify-connect-new-result-info-data">
              <div className="shopify-connect-new-result-info-data-credentials">
                {
                  nichesLoading ?
                    <div className="shopify-connect-new-result-info-data-credentials-item">
                      <div className="shopify-connect-new-result-info-data-credentials-item-label">
                        <span className={'link skeleton'} style={{ width: 36, height: 20, display: 'block' }} />
                      </div>
                      <div className="shopify-connect-new-result-info-data-credentials-item-value">
                        <span className={'link skeleton'} style={{ width: 260, height: 20, display: 'block' }} />
                      </div>
                    </div>
                    :
                    <div className="shopify-connect-new-result-info-data-credentials-item">
                      <div className="shopify-connect-new-result-info-data-credentials-item-label">
                        Email
                      </div>
                      <div className="shopify-connect-new-result-info-data-credentials-item-value">
                        {
                          nicheCreated?.pre_built_store?.user_name
                        }
                        <Divider type={'vertical'} style={{ margin: '0 12px' }} />
                        <span onClick={() => handleCopy(nicheCreated?.pre_built_store?.user_name, 'Email')}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M5.8335 10.1668V13.3335C5.8335 13.7937 6.20659 14.1668 6.66683 14.1668H13.3335C13.7937 14.1668 14.1668 13.7937 14.1668 13.3335V6.66683C14.1668 6.20659 13.7937 5.8335 13.3335 5.8335H10.1668M9.3335 10.1668H2.66683C2.20659 10.1668 1.8335 9.79373 1.8335 9.3335V2.66683C1.8335 2.20659 2.20659 1.8335 2.66683 1.8335H9.3335C9.79373 1.8335 10.1668 2.20659 10.1668 2.66683V9.3335C10.1668 9.79373 9.79373 10.1668 9.3335 10.1668Z"
                                  stroke="#225AEA"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                            />
                          </svg>
                          Copy
                        </span>
                      </div>
                    </div>
                }
                {
                  nichesLoading ?
                    <div className="shopify-connect-new-result-info-data-credentials-item">
                      <div className="shopify-connect-new-result-info-data-credentials-item-label">
                        <span className={'link skeleton'} style={{ width: 66, height: 20, display: 'block' }} />
                      </div>
                      <div className="shopify-connect-new-result-info-data-credentials-item-value">
                        <span className={'link skeleton'} style={{ width: 160, height: 20, display: 'block' }} />
                      </div>
                    </div>
                    :
                    <div className="shopify-connect-new-result-info-data-credentials-item">
                      <div className="shopify-connect-new-result-info-data-credentials-item-label">
                        Password
                      </div>
                      <div className="shopify-connect-new-result-info-data-credentials-item-value">
                        {
                          nicheCreated?.pre_built_store?.password
                        }
                        <Divider type={'vertical'} style={{ margin: '0 12px' }} />
                        <span onClick={() => handleCopy(nicheCreated?.pre_built_store?.password, 'Password')}>
                          <svg xmlns="http://www.w3.org/2000/svg"
                               width="16"
                               height="16"
                               viewBox="0 0 16 16"
                               fill="none"
                          >
                            <path d="M5.8335 10.1668V13.3335C5.8335 13.7937 6.20659 14.1668 6.66683 14.1668H13.3335C13.7937 14.1668 14.1668 13.7937 14.1668 13.3335V6.66683C14.1668 6.20659 13.7937 5.8335 13.3335 5.8335H10.1668M9.3335 10.1668H2.66683C2.20659 10.1668 1.8335 9.79373 1.8335 9.3335V2.66683C1.8335 2.20659 2.20659 1.8335 2.66683 1.8335H9.3335C9.79373 1.8335 10.1668 2.20659 10.1668 2.66683V9.3335C10.1668 9.79373 9.79373 10.1668 9.3335 10.1668Z"
                                  stroke="#225AEA"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                            />
                          </svg>
                          Copy
                        </span>
                      </div>
                    </div>
                }
                {
                  nichesLoading ?
                    <div className="shopify-connect-new-result-info-data-credentials-item">
                      <div className="shopify-connect-new-result-info-data-credentials-item-label">
                        <span className={'link skeleton'} style={{ width: 70, height: 20, display: 'block' }} />
                      </div>
                      <div className="shopify-connect-new-result-info-data-credentials-item-value">
                        <span className={'link skeleton'} style={{ width: 100, height: 20, display: 'block' }} />
                      </div>
                    </div>
                    :
                    <div className="shopify-connect-new-result-info-data-credentials-item">
                      <div className="shopify-connect-new-result-info-data-credentials-item-label">
                        Store Link
                      </div>
                      <div className="shopify-connect-new-result-info-data-credentials-item-value shopify-connect-new-result-info-data-credentials-item-value--clickable"
                           onClick={() => window.open(nicheCreated?.pre_built_store?.store_url, '_blank')}
                      >
                        {
                          nicheCreated?.store?.name.replaceAll(' ', '-')
                        }
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <path
                            d="M13.3333 7.33333C13.1565 7.33333 12.987 7.40357 12.8619 7.5286C12.7369 7.65362 12.6667 7.82319 12.6667 8V12C12.6667 12.1768 12.5964 12.3464 12.4714 12.4714C12.3464 12.5964 12.1768 12.6667 12 12.6667L4 12.6667C3.82319 12.6667 3.65362 12.5964 3.5286 12.4714C3.40357 12.3464 3.33333 12.1768 3.33333 12L3.33333 4C3.33333 3.82319 3.40357 3.65362 3.5286 3.5286C3.65362 3.40357 3.82319 3.33333 4 3.33333L8 3.33333C8.17681 3.33333 8.34638 3.2631 8.4714 3.13807C8.59643 3.01305 8.66667 2.84348 8.66667 2.66667C8.66667 2.48986 8.59643 2.32029 8.4714 2.19526C8.34638 2.07024 8.17681 2 8 2L4 2C3.46957 2 2.96086 2.21071 2.58579 2.58579C2.21071 2.96086 2 3.46957 2 4L2 12C2 12.5304 2.21071 13.0391 2.58579 13.4142C2.96086 13.7893 3.46957 14 4 14L12 14C12.5304 14 13.0391 13.7893 13.4142 13.4142C13.7893 13.0391 14 12.5304 14 12V8C14 7.82319 13.9298 7.65362 13.8047 7.5286C13.6797 7.40357 13.5101 7.33333 13.3333 7.33333Z"
                            fill="#707BA0" />
                          <path
                            d="M10.6668 3.33333L11.7201 3.33333L7.52679 7.52C7.4643 7.58197 7.41471 7.65571 7.38086 7.73695C7.34702 7.81819 7.32959 7.90532 7.32959 7.99333C7.32959 8.08134 7.34702 8.16848 7.38086 8.24972C7.41471 8.33096 7.4643 8.40469 7.52679 8.46667C7.58876 8.52915 7.6625 8.57875 7.74374 8.61259C7.82498 8.64644 7.91211 8.66387 8.00012 8.66387C8.08813 8.66387 8.17527 8.64644 8.25651 8.61259C8.33775 8.57875 8.41148 8.52915 8.47346 8.46667L12.6668 4.28V5.33333C12.6668 5.51014 12.737 5.67971 12.8621 5.80474C12.9871 5.92976 13.1566 6 13.3335 6C13.5103 6 13.6798 5.92976 13.8049 5.80474C13.9299 5.67971 14.0001 5.51014 14.0001 5.33333V2.66667C14.0001 2.48986 13.9299 2.32029 13.8049 2.19526C13.6798 2.07024 13.5103 2 13.3335 2L10.6668 2C10.49 2 10.3204 2.07024 10.1954 2.19526C10.0704 2.32029 10.0001 2.48986 10.0001 2.66667C10.0001 2.84348 10.0704 3.01305 10.1954 3.13807C10.3204 3.2631 10.49 3.33333 10.6668 3.33333Z"
                            fill="#707BA0" />
                        </svg>
                      </div>
                    </div>
                }
              </div>
            </div>
          </div>
          <Divider type={'horizontal'}
                   style={{ margin: '0 auto', width: 'calc(100% - 32px)', minWidth: 'calc(100% - 32px)' }}
          />
          <div className="shopify-connect-new-result-info">
            <div className="shopify-connect-new-result-info-title">
              <div className="shopify-connect-new-result-info-title-number">
                02
              </div>
              <span>
                {
                  t('Complete your subscription setup')
                }
              </span>
            </div>
            <div className="shopify-connect-new-result-info-data">
              <div className="shopify-connect-new-result-info-data-list">
                <p className={'shopify-connect-new-result-info-data-list-item'}>
                  1. Click the <span>“Open Shopify store plans”</span> button.
                </p>
                <p className={'shopify-connect-new-result-info-data-list-note'}>
                  <span>Note: </span>We have pre-selected <span>“Basic”</span> plan for your convenience, which is
                  available at a price of just <span>1$ for the first month.</span>
                </p>
                <p className={'shopify-connect-new-result-info-data-list-item'}>
                  2. Chose and enter your <span>payment method</span> details.
                </p>
                <p className={'shopify-connect-new-result-info-data-list-item'}>
                  3. Confirm your subscription by clicking <span>“Subscribe”</span> located on the right side of the
                  screen.
                </p>
              </div>
              <WarningBanner
                text={'If you don’t pay for your Shopify subscription you will lose access to your store in a short time.'} />
            </div>
          </div>
        </div>
        {
          isMobile ?
            null
            :
            <Divider type={'horizontal'}
                     style={{ margin: '0 auto 16px' }}
            />
        }
        <div className={'custom-modal-btn-wrapper'}>
          <ButtonComponent className={'custom-modal-button apply blue wide'}
                           onClick={() => window.open(`https://admin.shopify.com/store/${nicheCreated?.store?.name.replaceAll(' ', '-')}/subscription/pick_period/basic/monthly?online=true&selected=true`, '_blank')}
          >
            {t('Open Shopify store plans')}
          </ButtonComponent>
        </div>
      </Spin>
    ),
  };

  useEffect(() => {
    if (nichesStep === 0 && isVisibleModal === 'connect') {
      props.getPreBuiltStores();
    } else if (nichesStep === 2 && isVisibleModal === 'connect') {
      props.getNiches();
    } else if (nichesStep === 3 && Object.keys(nicheCreated).length) {
      props.setNichesStep(4);
    }
  }, [nichesStep, nicheCreated]);

  return (
    <Modal className={cls('shopify-connect shopify-connect-new')}
           title={modalTitle[nichesStep]}
           open={isVisibleModal === 'connect'}
           width={450}
           handleClose={handleClose}
           isMobile={isMobile}
           destroyOnClose={true}
           footer={false}
    >
      {
        modalContent[nichesStep]
      }
    </Modal>
  );
};

ModalShopifyConnect.defaultProps = {
  shopifyStore: {
    loading: false,
    results: [],
    isVisibleModal: null,
  },
};

const mapStateToProps = (state) => ({
  isMobile: state.nav.isMobile,
  theme: state.nav.theme,
  userInfo: state.auth.userInfo,
  shopifyStore: state.shopifyStore,
  dashboardInfo: state.dashboard.result,
});

const mapDispatchToProps = (dispatch) => ({
  verifyShopifyStore: (verify_params) => dispatch(Creators.verifyShopifyStoreRequest({ verify_params })),
  verifyShopifyStoreReset: () => dispatch(Creators.verifyShopifyStoreReset()),
  getNiches: () => dispatch(Creators.getPreBuiltStoresNichesRequest()),
  resetNiches: () => dispatch(Creators.resetNiches()),
  setNichesStep: (data) => dispatch(Creators.setNichesStep(data)),
  getPreBuiltStores: () => dispatch(Creators.getPreBuiltStoresRequest()),
  getPreBuiltStoreById: (id) => dispatch(Creators.getPreBuiltStoreByIdRequest(id)),
  createPreBuiltStore: (id) => dispatch(Creators.createPreBuiltStoreRequest(id)),
  closeModalConnect: () => dispatch(Creators.changeVisibleModalShopify({
    isVisibleModal: null,
    initialUrl: null,
    importProductId: null,
  })),
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalShopifyConnect);
